import { TicketsQuery } from '../../__generated__/graphql';
import { TicketsListItem } from '../../pages/Support/Tickets/types';
import { mapTicketListData } from '../../pages/Support/Tickets/mappings';

export const mapManagerTickets = (src: TicketsQuery): TicketsListItem[] => {
  return src.manager.tickets.items.map((x) => mapTicketListData(x));
};
